import { GalleriaDesignTokens } from '@primeuix/themes/types/galleria';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/galleria/index.ts
const ga = componentCommon.galleria;
const gaCs = componentColorScheme.galleria;

export const GalleriaTelekomDT: GalleriaDesignTokens = {
  root: {
    borderWidth: t(ga.border.width),
    borderColor: t(ga.border.color),
    borderRadius: t(ga.border.radius),
  },
  navButton: {
    background: t(ga.nav.button.background),
    hoverBackground: t(ga.nav.button.hover.background),
    color: t(ga.nav.button.color),
    hoverColor: t(ga.nav.button.hover.color),
    size: t(ga.nav.button.size),
    gutter: t(ga.nav.button.gutter),
    prev: { borderRadius: t(ga.nav.button.prev.border.radius) },
    next: { borderRadius: t(ga.nav.button.next.border.radius) },
    focusRing: {
      width: t(ga.nav.button.focus.ring.width),
      color: t(ga.nav.button.focus.ring.color),
      offset: t(ga.nav.button.focus.ring.offset),
    },
  },
  navIcon: {
    size: t(ga.nav.icon.size),
  },
  thumbnailsContent: {
    background: t(ga.thumbnails.content.background),
    padding: `${t(ga.thumbnails.content.padding.y)} ${t(ga.thumbnails.content.padding.x)}`,
  },
  thumbnailNavButton: {
    size: t(ga.thumbnail.nav.button.size),
    gutter: t(ga.thumbnail.nav.button.gutter),
    borderRadius: t(ga.thumbnail.nav.button.border.radius),
    color: t(gaCs.thumbnail.nav.button.color),
    hoverBackground: t(gaCs.thumbnail.nav.button.hover.background),
    hoverColor: t(gaCs.thumbnail.nav.button.hover.color),
    focusRing: {
      width: t(ga.thumbnail.nav.button.focus.ring.width),
      color: t(ga.thumbnail.nav.button.focus.ring.color),
      offset: t(ga.thumbnail.nav.button.focus.ring.offset),
    },
  },
  thumbnailNavButtonIcon: {
    size: t(ga.thumbnail.nav.button.icon.size),
  },
  caption: {
    background: t(ga.caption.background),
    color: t(ga.caption.color),
    padding: t(ga.caption.padding),
  },
  indicatorList: {
    gap: t(ga.indicator.list.gap),
    padding: t(ga.indicator.list.padding),
  },
  indicatorButton: {
    width: t(ga.indicator.button.width),
    height: t(ga.indicator.button.height),
    borderRadius: t(ga.indicator.button.border.radius),
    activeBackground: t(ga.indicator.button.active.background),
    background: t(gaCs.indicator.button.background),
    hoverBackground: t(gaCs.indicator.button.hover.background),
    focusRing: {
      width: t(ga.indicator.button.focus.ring.width),
      color: t(ga.indicator.button.focus.ring.color),
      offset: t(ga.indicator.button.focus.ring.offset),
    },
  },
  insetIndicatorList: {
    background: t(ga.inset.indicator.list.background),
  },
  insetIndicatorButton: {
    background: t(ga.inset.indicator.button.background),
    hoverBackground: t(ga.inset.indicator.button.hover.background),
    activeBackground: t(ga.inset.indicator.button.active.background),
  },
  closeButton: {
    size: t(ga.close.button.size),
    gutter: t(ga.close.button.gutter),
    background: t(ga.close.button.background),
    hoverBackground: t(ga.close.button.hover.background),
    color: t(ga.close.button.color),
    hoverColor: t(ga.close.button.hover.color),
    borderRadius: t(ga.close.button.border.radius),
    focusRing: {
      width: t(ga.close.button.focus.ring.width),
      color: t(ga.close.button.focus.ring.color),
      offset: t(ga.close.button.focus.ring.offset),
    },
  },
  closeButtonIcon: {
    size: t(ga.close.button.icon.size),
  },
};
